import React from 'react';
import jMoment from 'moment-jalaali';
import { numberWithCommas } from 'utility/util';
const columns = (PayBtn, actionsList , currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه فاکتور',
    field: 'subjectInvoice.id',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (row?.subjectInvoice?.id || '-'),

  },
  {
    title: 'مبلغ فاکتور',
    field: 'subjectInvoice.payableAmount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => (numberWithCommas(row?.subjectInvoice?.payableAmount) || '-'),
  },
  {
    title: 'تاریخ پرداخت فاکتور',
    field: 'subjectInvoice.paymentDate',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) =>
      (row && row?.subjectInvoice?.paymentDate) ? (
        <div>
          <bdi style={{ direction: 'ltr' }}>
            {parseDataSplit(row?.subjectInvoice?.paymentDate)[0]}
          </bdi>
        </div>) : '-'
  },
  {
    title: 'وضعیت فاکتور',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'multiConfirmationSrv?.enable',
    render: (row) => row?.subjectInvoice?.payed == true ? 'پرداخت شده' : 'پرداخت نشده'
  },
  ...(actionsList['invoiceFinancingPayAction'] ? [{
    title: 'عملیات',
    field: 'operationFull',
    filtering: false,
    align: 'center',
    sorting: false,
    render: (row) => (PayBtn ? <PayBtn row={row} /> : <div />),
  }] : []),
];
const parseDataSplit = (date) => {
  let t = jMoment(new Date(date))?.format(
    'jYYYY/jMM/jDD HH:mm:ss',
  )
  return t.split(' ');
}

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
